import { CustomerData } from "../interfaces/individualCustomer";

export const individualCustomerData: CustomerData = {
  accounts: [
    {
      clientId: 75613,
      accountNumber: "8090692356",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "08/02/2024 06:58:59",
    },
    {
      clientId: 75613,
      accountNumber: "9072846347",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 82000,
      lastActive: "08/01/2024 12:17:43",
    },
    {
      clientId: 75613,
      accountNumber: "9056778020",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/25/2024 06:20:12",
    },
    {
      clientId: 75613,
      accountNumber: "9076789004",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/24/2024 20:58:08",
    },
    {
      clientId: 75613,
      accountNumber: "9078672345",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 34420,
      lastActive: "07/31/2024 10:55:04",
    },
    {
      clientId: 75613,
      accountNumber: "8790000091",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/16/2024 06:47:55",
    },
    {
      clientId: 75613,
      accountNumber: "8099996777",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 66000,
      lastActive: "07/31/2024 10:52:44",
    },
    {
      clientId: 75613,
      accountNumber: "9076543276",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/12/2024 12:51:26",
    },
    {
      clientId: 75613,
      accountNumber: "9056853138",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/09/2024 10:11:11",
    },
    {
      clientId: 75613,
      accountNumber: "9056853139",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/09/2024 09:57:44",
    },
    {
      clientId: 75613,
      accountNumber: "9088886545",
      accountName: "Eulah Nienow",
      product: "Savings Product",
      status: "300",
      availableBalance: 0,
      lastActive: "07/05/2024 21:09:30",
    },
  ],
  personalDetails: {
    firstName: "Tracey",
    middleName: null,
    lastName: "Strosin",
    emailAddress: "akah@yopmail.com",
    countryDialCode: "+234",
    countryFlag: "https://cdn.kcak11.com/CountryFlags/countries/ng.svg",
    phoneNumber: "08090692356",
    gender: "Female",
    maritalStatus: {
      id: 2,
      name: "Married",
      description: null,
    },
    numberOfChildren: null,
    bvn: "22280942098",
    nin: null,
  },
  employmentDetails: {
    educationalQualification: {
      id: null,
      name: null,
      description: null,
    },
    employmentStatus: {
      id: null,
      name: null,
      description: null,
    },
    employmentStartDate: null,
  },
  username: "akah@yopmail.com",
  residentialDetails: {
    typeOfResidence: {
      id: null,
      name: null,
      description: null,
    },
    address: "No 3 Ikoyi",
    city: "Victoria Island",
    state: "Lagos State",
    countryCode: "NG",
  },
  nextOfKin: {
    firstName: "Sally",
    lastName: "Akah",
    countryDialCode: "+234",
    countryFlag: "https://cdn.kcak11.com/CountryFlags/countries/ng.svg",
    phoneNumber: "08090692356",
    email: "sakah@yopmail.com",
    relationshipType: {
      id: 1,
      name: "Spouse",
      description: null,
    },
    street: "4 Ikoyi road",
    city: "Victoria Island",
    state: "Lagos State",
    countryCode: "NG",
  },
  documents: [
    {
      documentName: "Govt Issued Identity Document",
      documentType: "Water Bill",
      fileName: "img_5_1717660258306_jpg_020820240702000859.jpg",
      documentUrl:
        "documents/onboarding/Tracey_Strosin/img_5_1717660258306_jpg_020820240702000859.jpg",
      documentCode: "GII",
      status: {
        id: 1,
        name: "Pending",
        description: null,
      },
    },
    {
      documentName: "Proof of Address Individual",
      documentType: "Voter's Card",
      fileName:
        "what_is_integration_testing_examples_challenges_and_approaches_simplilearn_pdf_020820240702003500.pdf",
      documentUrl:
        "documents/onboarding/Tracey_Strosin/what_is_integration_testing_examples_challenges_and_approaches_simplilearn_pdf_020820240702003500.pdf",
      documentCode: "PAI",
      status: {
        id: 1,
        name: "Pending",
        description: null,
      },
    },
  ],
  tier: "Tier 1",
  totalAccountBalance: 20000,
};

export const customerAccountDetails = {
  product: "Savings Product",
  accountNumber: "8090692356",
  availableBalance: 5995000,
  currentBalance: 5995000,
  activatedOn: "19 Aug 2024",
  officerAssigned: "Unassigned",
  currency: "Nigerian Naira [NGN]",
  totalWithdrawals: 5000,
  interestEarned: 0,
  nominalInterestRate: "0.000000",
  totalDeposits: 6000000,
  totalInterestEarned: 0,
};
